package one.healthium.settings.ui.components

import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.components.AppIcons
import org.jetbrains.compose.resources.painterResource

@Composable
fun ArrowIcon() {
    Icon(
        modifier = Modifier.size(width = 8.dp, height = 13.dp),
        painter = painterResource(AppIcons.icArrowRight),
        contentDescription = null,
    )
}